<script>
/**
 * button component use for main card layout
 */
export default {
  props: {
    label: {
      type: String,
      require: true,
      default: 'login',
    },
  },
}
</script>

<template>
  <v-btn
    v-bind="$attrs"
    outlined
    x-large
    block
    rounded
    class="white--text font-weight-bold idoors-btn-main-card"
    type="submit"
    v-on="$listeners"
    >{{ this.$t(label) }}</v-btn
  >
</template>

<style lang="sass" scoped>
.idoors-btn-main-card
  border: 3px solid map-get($shades, 'white')
</style>
